import Webcam from 'react-webcam';
import { Spinner } from "src/components";
import { IconFactory } from 'src/factory/icon.factory';
import { CameraFacade } from '../../controller/facades/camera.facade';

import './Camera.scss';

/**
 *
 */
interface ICamera {

  onSelect: (picture: string) => void;

  onCancel: () => void;
}


/**
 *
 */
const Camera = (props: ICamera): JSX.Element => {
  const { cameraAvailable } = CameraFacade.usePermissions();
  const { states, actions } = CameraFacade.useCamera(cameraAvailable, props.onSelect);

  return (
    <div className="camera-wrapper height-100 width-100 fixed flex justify-center" style={{animation: states.currentAnimation}}>
      <button type="button" className="cancel-button absolute" onClick={(e) => {e.preventDefault(); actions.cancelPicture(props.onCancel)}}>
        {IconFactory.leftArrowIcon()}
        <span className="inline-block vertical-align-middle">Volver</span>
      </button>

      {
        !states.currentPicture ?
          <>
            {
              states.isLoading.value || cameraAvailable === undefined ?
                <Spinner color="white" />
                :
                <>
                  {
                    cameraAvailable === true &&
                    <Webcam
                      autoPlay={true}
                      width={states.windowSize.width}
                      height={states.windowSize.height}
                      audio={false}
                      ref={cameraAvailable !== true ? null : states.webcamRef}
                      screenshotFormat="image/jpeg"
                      videoConstraints={states.videoConstraints}
                      playsInline
                      forceScreenshotSourceSize={true}
                      style={{ objectFit: 'contain' }}
                    />
                  }

                  {
                    cameraAvailable === false &&
                    <div className="camera-permissions-message text-center">
                      {IconFactory.cameraIcon()}
                      <h3>Necesitas activar los permisos de la c&aacute;mara para continuar</h3>
                    </div>
                  }
                </>
            }
          </>
          :
          <div className="current-camera-image flex align-center justify-center ">
            <img className="width-100" src={states.currentPicture} alt="CurrentImage" />
          </div>
      }
      <div className="camera-actions absolute flex">
        {
          !states.currentPicture &&
          <button type="button" disabled={!cameraAvailable} onClick={actions.takePicture} className="take-picture"></button>
        }

        {
          states.currentPicture &&
          <>
            <button type="button" onClick={actions.removeCurrentPicture}>
              {IconFactory.closeIcon()}
            </button>
            <button type="button" onClick={(e) => {e.preventDefault(); actions.selectCurrentPicture(props.onCancel)}}>
              {IconFactory.checkIcon()}
            </button>
          </>
        }
      </div>

    </div>
  );
};

export default Camera;